module.exports = __webpack_public_path__ + "static/media/traffic-light-go.2e0506b4.svg";